module.exports = __webpack_public_path__ + "static/img/代金券.d9c14de.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/center/代金券.png
// module id = 46
// module chunks = 18